import StoreUtil from '@/store/StoreUtil'

export default {
  NEXT: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.notification, 'next'),
}
